export const TerasService = {
  getDefaultCraftFee: () => 5000,
  getDefaultExtractFee: () => 5000,
  getDefautlJunkConvertFee: () => 0,
  getDefaultDismantleFee: () => 13000,
}
